import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    user: null,
    solutions: [
      {
        id: 'industrial',
        title: '工业物联网',
        description: '实现工厂智能化改造，提升生产效率',
        features: [
          '设备远程监控',
          '生产数据分析',
          '预测性维护',
          '能源管理'
        ]
      },
      {
        id: 'smart-city',
        title: '智慧城市',
        description: '构建智能化城市管理系统',
        features: [
          '智能交通管理',
          '环境监测',
          '公共安全',
          '能源管理'
        ]
      },
      {
        id: 'agriculture',
        title: '智慧农业',
        description: '打造现代化农业生产系统',
        features: [
          '土壤监测',
          '气象数据采集',
          '灌溉控制',
          '病虫害防治'
        ]
      }
    ]
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_USER(state, user) {
      state.user = user
    }
  },
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status)
    },
    setUser({ commit }, user) {
      commit('SET_USER', user)
    }
  },
  getters: {
    isLoading: state => state.loading,
    currentUser: state => state.user,
    getSolutionById: (state) => (id) => {
      return state.solutions.find(solution => solution.id === id)
    }
  }
}) 